import formatPhone from '@/utils/format-phone';

export default (object) => {
  const phoneNumber = formatPhone(object.mainPhoneNumber);
  return {
    ...object,
    phoneNumber,
  };
};
